(function ( $ ) {

	$.fn.smoothscroll = function () {
		var $elem = $( this ),
			targetId = $elem.attr( 'href' ),
			$target = $( targetId ),
			scrollSpeed = 1000;

		var init = function () {

			if ( $target.length > 0 ) {
				$elem.on( 'click', function ( e ) {
					e.preventDefault();

					$( 'html, body' ).animate( {
						scrollTop : $target.offset().top
					}, scrollSpeed );
				} );
			}
		};

		init();
		return this;
	};

}( jQuery ));